<app-breadcrumb></app-breadcrumb>
<div class="md:w-2/3">
    <form [formGroup]="exitAccountFormGroup" (ngSubmit)="confirmation()">
        <mat-card class="bg-paper">
            <div class="px-6 pb-4">
                <div class="import-keys-form">
                    <div class="text-white text-xl mt-4">
                        Account Exit
                    </div>
                    <div class="my-6 text-hint text-lg leading-relaxed">
                        Please make sure you understand the consequences of
                        performing a voluntary exit. Once an account is exited,
                        the
                        action cannot be reverted.
                        You will not be able to withdraw your ETH if exited
                        until
                        ETH1 is merged with ETH2, which could happen in over a
                        year
                    </div>
                    <app-accounts-form-selection [publicKey]="publicKey"
                        [formGroup]="exitAccountFormGroup"></app-accounts-form-selection>
                    <mat-form-field class="w-2/3">
                        <mat-label>Confirmation</mat-label>
                        <input matInput formControlName="confirmation" />
                        <mat-hint>
                            <span>
                                Type <i>'agree'</i> if you want to exit the keys
                            </span>
                        </mat-hint>
                        <mat-error>
                            <span
                                *ngIf="exitAccountFormGroup?.get('confirmation')?.hasError('required')">
                                Confirmation is required</span>

                            <span
                                *ngIf="exitAccountFormGroup?.get('confirmation')?.hasError('incorectValue')">
                                You must type 'agree'
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <mat-card-actions>
                    <div class="btn-container pl-2">
                        <button mat-raised-button type="button"
                            (click)="back()" color="accent">Back
                            to
                            Accounts</button>
                        <button mat-raised-button mat-raised-button
                            [disabled]="exitAccountFormGroup?.invalid"
                            color="primary">
                            Confirm
                        </button>
                    </div>
                </mat-card-actions>
            </div>
        </mat-card>
    </form>
</div>